<ng-container #vcListMasterFormWidget></ng-container>
<ng-template
             #tmplListMasterFormWidget>
             <list-master-form-widget *ngIf="!!config" [config]="config"></list-master-form-widget>
</ng-template>             

